// extracted by mini-css-extract-plugin
export default {"item":"Cmrz2e","button":"sbzBDe","disabled":"oYcrSt","active":"LzSpny"};